// extracted by mini-css-extract-plugin
export default {"root":"style_root__ZyGLw","container":"style_container__bAhKC"};